export default __webpack_public_path__ + "static/media/cfs.660e26a0.png";